export default "__VITE_ASSET__BKiZulKm__ 1920w";